import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import {
  CheckboxField, FormAlert, FormGroup, handleFormError, InputText, RadioDropdown,
} from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';
import validate from '@saucelabs/sl-util-validate';
import { dataCentersList, CURRENT_DC, DEFAULT_DC } from '@saucelabs/sl-util-config';

import Styles from './LoginForm.styles';
import * as types from './../ducks/types';


const LoginForm = ({ error, handleSubmit, shouldRenderDCDropdown, submitting }) => (
  <form onSubmit={handleSubmit}>
    <FormAlert type="danger">{error}</FormAlert>
    <Row>
      <Col xs>
        <Field
          className="form-control"
          component={InputText}
          name="username"
          placeholder="Username or email address"
          type="text"
        />
      </Col>
    </Row>
    <Row>
      <Col
        className={Styles['form-group-password']}
        xs
      >
        <Field
          className="form-control"
          component={InputText}
          name="password"
          placeholder="Password"
          type="password"
        />
        <Link
          className={Styles['forgot-link']}
          tabIndex="-1"
          to="/send-password-reset"
        >
            Forgot?
        </Link>
      </Col>
    </Row>
    {shouldRenderDCDropdown && (
      <Row>
        <Col xs>
          <Field
            className="form-control"
            component={RadioDropdown}
            etiquette="Select Data Center Location"
            isInputForm
            label="Data Center"
            name="data_center"
            options={dataCentersList.map((datacenter) => ({
              text: datacenter.label,
              value: datacenter.value,
            }))}
            type="input"
          />
        </Col>
      </Row>
    )}

    <FormGroup>
      <Row middle="xs">
        <Col xs={5}>
          <CheckboxField
            fieldName="remember_me"
            id="remember_me"
            label="Remember Me"
            name="remember_me"
            value
          />
        </Col>
        <Col xs={7}>
          <Button
            block
            category="action"
            className={Styles['submit-button']}
            disabled={submitting}
            id="submit"
            type="submit"
            withArrow
          >
              Sign In
          </Button>
        </Col>
      </Row>
    </FormGroup>
  </form>
);

LoginForm.propTypes = {
  error: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
  shouldRenderDCDropdown: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

LoginForm.defaultProps = {
  error: undefined,
};

const constraints = {
  username: {
    presence: { allowEmpty: false },
  },
  password: {
    presence: { allowEmpty: false },
  },
  data_center: {
    presence: { allowEmpty: false },
  },
};

const LoginFormWrapper = reduxForm({
  form: types.LOGIN_FORM,
  enableReinitialize: true,
  validate: (values) => validate(values, constraints, { format: 'grouped' }),
  onSubmit: (values, dispatch, formProps) => (
    formProps.loginUser({ nextQueryParam: formProps.nextQueryParam, ...values })
      .catch(({ response }) => {
        handleFormError({
          dispatch,
          status: response.status,
          errors: {},
          message40x: response.data.error && response.data.error.message,
        });
      })
  ),
})(LoginForm);

LoginFormWrapper.propTypes = {
  loginUser: PropTypes.func.isRequired,
};

const mapStateToProps = ({ apps: { auth } }) => ({
  initialValues: {
    // on non-default DC it should always login to the specific DC
    data_center: CURRENT_DC === DEFAULT_DC ? auth.get('latestDataCenter') : CURRENT_DC,
  },
  // render DC dropdown only on main login
  shouldRenderDCDropdown: !!(CURRENT_DC === DEFAULT_DC && dataCentersList.length),
});

const LoginFormWrapperContainer = connect(mapStateToProps)(LoginFormWrapper);

export default LoginFormWrapperContainer;
export { LoginForm, LoginFormWrapper, mapStateToProps };
